<template>
    <div>
        <van-tabs v-model="activeIndex">
            <van-tab title="全部">
                <order-list :p_action="action" :p_status="0" :p_enable_detail="enable_show_detail" />
            </van-tab>
            <van-tab title="待支付">
                <order-list :p_action="action" :p_status="1" :p_enable_detail="enable_show_detail" />
            </van-tab>
            <van-tab title="待发货">
                <order-list :p_action="action" :p_status="2" :p_enable_detail="enable_show_detail" />
            </van-tab>
            <van-tab title="已完成">
                <order-list :p_action="action" :p_status="9" :p_enable_detail="enable_show_detail" />
            </van-tab>
        </van-tabs>
        <partner-footer p_active="1" />
    </div>
</template>

<script>
    /*
     * 我的订单 - 终端用户
     */
    import OrderList from "../../components/Order/OrderList";
    import PartnerFooter from "../../components/Footer/PartnerFooter";
    import store from '@/store';
    import config from '@/config';

    export default {
        name: "MyOrderClient",
        components: {PartnerFooter, OrderList},
        data(){
            return{
                activeIndex:this.$route.params.status?this.$route.params.status:0,
                action:'1',
                enable_show_detail:true,
            }
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            if(loginUser&&loginUser.openid){
                next();
            }else{
                //梅唐四季，则直接提示授权登录
                //未登录，则发起微信登录授权
                let code = to.query.code;
                let sales_uid='';   //首次打开此页说明是主动进入公众号并从菜单进入本页，所以没渠道号
                let mode=1; //梅唐四季模式
                if(code){
                    store.dispatch('WeixinLogin',{code,sales_uid,mode}).then(res=>{
                        if(res.status>0){
                            //登录失败
                            next(false);
                        }else{
                            //成功
                            next();
                        }
                    });
                }else{
                    //无code则表示是第一次进入本页，发起微信授权
                    // let redirect_uri=encodeURIComponent(config.weixin.redirect_dev); //debug
                    let redirect_uri = encodeURIComponent(window.location.href);
                    let appid=config.weixin.appid_mt;
                    let state='';
                    let auth_url= 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                        'appid=' +appid+
                        '&redirect_uri=' +redirect_uri+
                        '&response_type=code&scope=snsapi_userinfo&' +
                        'state=' +state+
                        '#wechat_redirect';
                    // console.log('weixin auth url',auth_url);
                    window.location.href = auth_url;
                }
            }
        },
    }
</script>

<style scoped>

</style>